;(function(EG) {
  'use strict';

  EG.Users.Profile.Models.UserCustomDataField = EG.Users.Models.Base.extend({
    defaults: {
      code: undefined,
      definition_id: undefined,
      id: undefined,
      label: undefined
    }
  });

  EG.Users.Profile.Collections.UserCustomDataFields = EG.Users.Collections.Base.extend({
    model: EG.Users.Profile.Models.UserCustomDataField,

    initialize: function(userId) {},

    findModelById: function(id) {
      return this.findWhere({
        id: parseInt(id, 10)
      });
    },

    getCostCenterByType: function(costCenterType) {
      return this.findWhere({
        code: costCenterType,
      });
    },
  });
})(EG);
